'use strict';

angular.module('AcaApp').directive('ngFormatCurrency', [
  'UtilsService',
  '$timeout',
  function(UtilsService, $timeout){
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl){
        element.bind('change', function(){
          element.val(UtilsService.getCurrencyFormat(element.val(), 2));
        });
        $timeout(
          function(){
            element.val(UtilsService.getCurrencyFormat(element.val(), 2));
          }
        );
        modelCtrl.$parsers.push(function(inputValue){
          if(inputValue === undefined){
            return '';
          }
          var transformedInput = inputValue.replace(/[^0-9.]/g, '');
          if(transformedInput != inputValue){
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }
          return transformedInput;
        });
      }
    };
  }
]);
